import { render } from "./SelectMyPicks.vue?vue&type=template&id=81ca5270&scoped=true"
import script from "./SelectMyPicks.vue?vue&type=script&lang=js"
export * from "./SelectMyPicks.vue?vue&type=script&lang=js"

import "./SelectMyPicks.vue?vue&type=style&index=0&id=81ca5270&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ca5270"]])

export default __exports__